import cx from 'classnames';
import { renderDesignTokens, useDesignTokens } from '../../../theme';
import { Heading } from '../../Heading';
import cn from './GroupHeaderItem.css.json';
import './GroupHeaderItem.css';

/**
 * The GroupHeaderItem component that renders the group header element.
 *
 * <b>Note:</b> The GroupHeaderItem is meant to use either a ListProps's
 * `renderItem` or ListColumnProps's `item`, which will display
 * at the body of the item.
 *
 * @component
 * @param {GroupHeaderItemProps} props the GroupHeaderItemProps properties
 * @returns the Item element
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const GroupHeaderItem = props => {
  const dt = useDesignTokens();
  const tokens = {
    ...getGroupHeaderItemDesignTokens(dt, {
      tokens: props.tokens
    }),
    ...props.theme?.(dt)
  };
  const itemContent = /*#__PURE__*/_jsx(Heading, {
    disabled: props.disabled,
    level: 6,
    title: props.tooltip,
    style: {
      ...tokens,
      ...props.style
    },
    className: cx(cn.groupItemText, props.className),
    "data-testid": props.testId,
    children: props.title
  });
  return itemContent;
};
export const getGroupHeaderItemDesignTokens = (dt, opts) => {
  return {
    ...renderDesignTokens({
      fg: opts?.tokens?.fg ?? dt.tokens['color-action-text-subtle-normal']
    }, 'list-group-header'),
    ...(!dt.enableNovaTokens && getGroupHeaderItemLegacyDesignTokens(dt, opts))
  };
};
export const getGroupHeaderItemLegacyDesignTokens = (dt, opts) => {
  return {
    ...renderDesignTokens({
      fg: opts?.tokens?.fg ?? (dt.themeVariant === 'light' ? dt.c.n_3 : dt.c.white)
    }, 'list-group-header')
  };
};
//# sourceMappingURL=GroupHeaderItem.js.map